import { render, staticRenderFns } from "./BlogPublicV.vue?vue&type=template&id=0f120240&scoped=true"
import script from "./BlogPublicV.vue?vue&type=script&lang=js"
export * from "./BlogPublicV.vue?vue&type=script&lang=js"
import style0 from "./BlogPublicV.vue?vue&type=style&index=0&id=0f120240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f120240",
  null
  
)

export default component.exports